export default "__VITE_ASSET__MnYvsuZl__"